import React from 'react'

import OrdersEmpty from '../../../assets/orders-empty.svg'
import '../MyOrdersPage.css'

export const NoOrders = () => (
  <div styleName='emptyNotification'>
    <OrdersEmpty />
    <h3 styleName='emptyNotificationHeader'>Place your first order!</h3>
    <h4 styleName='emptyNotificationInfo'>Once an order is complete, it will be listed here.</h4>
  </div>
)
